import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './header';
import { Footer }  from './footer';

// ヘッダに持つ情報の型定義
export interface OutletContextType {
  userId: string;
  setUserId: React.Dispatch<React.SetStateAction<string>>;
  setUserName: React.Dispatch<React.SetStateAction<string>>;
  setPictureUrl: React.Dispatch<React.SetStateAction<string>>;
}

export const Root = () => {
  const [userId, setUserId] = useState("");
  const [userName, setUserName] = useState("");
  const [pictureUrl, setPictureUrl] = useState("");

  return (
    <>
      {/* ヘッダ */}
      <Header 
        userId={userId} 
        setUserId={setUserId} 
        userName={userName} 
        setUserName={setUserName} 
        pictureUrl={pictureUrl} 
        setPictureUrl={setPictureUrl} 
      />

      {/* 画面コンテンツ */}
      <div id="detail">
        <Outlet context={{ userId, setUserId, setUserName, setPictureUrl }} />
      </div>

      {/* フッタ */}
      <Footer />
    </>
  );
};
